module.exports = __webpack_public_path__ + "img/clinicListicon.ea2f638a.svg";